import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Navbar from './Components/Navbar/Navbar';

export default function Layout() {
  return (
    <div>
      <Navbar />
      <Container>
        <Outlet />
      </Container>
    </div>
  );
}
